import react from "./react.webp";
import tailwind from "./tailwind.webp";
import css from "./css.webp";
import express from "./express.webp";
import git from "./git.webp";
import firebase from "./firebase.webp";
import javascript from "./javascript.webp";
import node from "./node.webp";
import SQL from "./SQL.webp";
import mysql from "./mysql.webp";
import HTML from "./HTML.webp";
import figma from "./figma.webp";
const techStack = {
  react,
  tailwind,
  css,
  express,
  git,
  firebase,
  javascript,
  node,
  SQL,
mysql,
HTML,
figma

};

export default techStack;
